import React, { Component } from "react"
import FileInputComponent from 'react-file-input-previews-base64'
import trans from "trans"
import TransparentColor from "./transparent-color";

import {
    Grid,
    GridCell,
    Button,
    Theme,
    Icon,
    css,
} from "@bdfx/mergado-ui-kit"


import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE_KB, MAX_UPLOAD_FILE_PX } from "./helpers"
import toastFactory, { ResponseErrorType } from "app/helpers/toast_factory"
import store from "store"
import { createToast } from "actions"
import { UPLOAD_IMAGE_FILE } from "template-edit/reducers"
import ShapeType from "shape-entities/types/shape"
import { NumericInput } from "./fields";
import ChangeSvgColors from "./change-svg-colors";
import { FormNameType } from "app/types/model-types";
import { TemplateOrAlternativeTemplateType } from "template-edit/undoRedoReducers";

interface Props {
    form: TemplateOrAlternativeTemplateType
    formName: FormNameType
    change: Function
    shape: ShapeType
}

class BitmapForm extends Component<Props> {
    constructor(props) {
        super(props)
    }

    render() {
        const { form, formName, shape, change } = this.props

        return (
            <div>
                <Grid cols={"50% 50%"} gap={'5px'}>
                    {/* <GridCell>{trans('frame_image')}</GridCell>
                    <GridCell>
                        <StyledToggler
                            value={shape.stroke_width > 0}
                            onChange={(e) => change(formName, `shapes.${shape.index}.stroke_width`, e ? e : null)}
                        />
                    </GridCell> */}

                    {shape.imageBlob &&
                        <CenteredOneGridCell>
                            <StyledImg src={shape.imageBlob} title={trans('custom_image_set_selected_image')} />

                            <div>
                                <ChangeSvgColors shape={shape} />
                            </div>
                        </CenteredOneGridCell>
                    }

                    {shape.stroke_width &&
                        <React.Fragment>
                            <GridCell>{trans('stroke_width')}</GridCell>
                            <GridCell style={{ position: 'relative' }}>
                            <NumericInput
                                    formName={formName}
                                    fieldName={'stroke_width'}
                                    placeholder={'stroke_width'}
                                    shapeIndex={shape.index}
                                    id={'stroke-input'}
                                    min={0}
                                    max={100}
                                    step={1}
                                    units={'px'}
                                    value={Math.round(shape.stroke_width)}
                                    onlyPositive={true}
                                />
                            </GridCell>
                            <GridCell>{trans('stroke_color')}</GridCell>
                            <GridCell style={{ paddingRight: '5px' }}>
                                <TransparentColor
                                name={`${formName}.shapes.${shape.index}.stroke_color`}
                                    value={shape.stroke_color}
                                    changeValue={(color) => {
                                        change(formName, `shapes.${shape.index}`, { ...shape, stroke_color: color })
                                    }}
                                />
                            </GridCell>
                        </React.Fragment>
                    }

                    <GridCell>{trans("file")}</GridCell>
                    <GridCell>
                        <FileInputComponent
                            key={`key_file_input_${shape.index}`}
                            id={`file_input_${shape.index}`}
                            parentStyle={{ marginTop: 0, display: "inline-block", marginBottom: '40px' }}
                            labelStyle={{ fontSize: 14 }}
                            labelText={''}
                            imagePreview={false}
                            multiple={false}
                            buttonComponent={
                                <Button
                                    id={`file_upload_${shape.index}`}
                                    type="void"
                                    color={Theme.blue}
                                    size={"smaller"}
                                    secondary={true}
                                    icon={<Icon type={'upload-light'} text={shape.name || trans('upload_image')} />}
                                />
                            }
                            callbackFunction={(file) => {
                                if (file.size > MAX_FILE_SIZE_KB) {
                                    const error: ResponseErrorType = {
                                        message: 'upload_error_large_file',
                                        response: null
                                    }

                                    store.dispatch(createToast(toastFactory(UPLOAD_IMAGE_FILE.ERROR, error)))
                                } else if (ALLOWED_FILE_TYPES.indexOf(file.type) === -1) {
                                    const error: ResponseErrorType = {
                                        message: 'upload_error_unsupported_type',
                                        response: null
                                    }

                                    store.dispatch(createToast(toastFactory(UPLOAD_IMAGE_FILE.ERROR, error)))
                                } else {
                                    let img = new Image()
                                    img.src = file.base64
                                    img.onload = () => {
                                        if (img.width * img.height > MAX_UPLOAD_FILE_PX) {
                                            const error: ResponseErrorType = {
                                                message: 'upload_error_image_too_big',
                                                response: null
                                            }
                                            store.dispatch(createToast(toastFactory(UPLOAD_IMAGE_FILE.ERROR, error)))
                                        } else {
                                            const newShape: ShapeType = {
                                                ...shape,
                                                width: img.width > 0 ? img.width : 100,
                                                height: img.height > 0 ? img.height : 100,
                                                imageBlob: file.base64,
                                                name: file.name,
                                            }
                                            change(formName, `shapes.${shape.index}`, newShape)
                                        }
                                    }
                                }
                            }}
                            accept="image/*"
                        />
                    </GridCell>
                </Grid>
            </div>
        )
    }
}

const CenteredOneGridCell = css(GridCell)({
    gridColumn: '1/-1',
    textAlign: 'center',
    alignSelf: 'center',
})

const StyledImg = css('img')({
    textAlign: 'center',
    maxWidth: '80%',
    maxHeight: '200px',
    width: 'auto',
    height: 'auto',
});

export default BitmapForm